import { ChatParticipantDto } from "@/core/api/generated/v1";
import { selectChatCurrentParticipant } from "@/store/communication/selectors";

import { useTenantProfileV2 } from "../entity/tenant/useTenantProfileV2";
import { useAppSelector } from "../redux";
import { useUserProfile } from "../user/useUserProfile";

/** @deprecated Use chat context.
 * Returns chat participant for currently authenticated user. */
export const useChatCurrentParticipant = (
  chatId: string | null | undefined,
): ChatParticipantDto | undefined => {
  const tenantProfile = useTenantProfileV2();
  const profile = useUserProfile();

  const currentParticipant = useAppSelector((x) =>
    selectChatCurrentParticipant(x, chatId, tenantProfile?.profile?.id, profile?.id),
  );

  return currentParticipant;
};
